/**
 * @generated SignedSource<<5c7b29911f69534ee5c7783a5dca1508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserBackgroundPhoto_user$data = {
  readonly backgroundPhoto: {
    readonly " $fragmentSpreads": FragmentRefs<"GraphQLImage_image">;
  } | null | undefined;
  readonly rowId: string;
  readonly " $fragmentType": "UserBackgroundPhoto_user";
};
export type UserBackgroundPhoto_user$key = {
  readonly " $data"?: UserBackgroundPhoto_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserBackgroundPhoto_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserBackgroundPhoto_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GraphQLImage_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c3291c1fd76f7bd6dd5b7025e6187ea9";

export default node;
